import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useMediaQuery } from 'react-responsive';
import useAnimations from '../../../hooks/useAnimations';
import { device } from '../../../styles/devices';
import ExposedHeader from '../ExposedHeader';
import Offers from '../Offers';
import {
  MobileWrapper,
  VehicleInfoContainer,
  Title,
  OfferType,
  CreditBonus,
  CreditBonusDescription,
  Trimline,
  VehicleImage,
  ImageWrapper,
  VehicleName,
} from '../VehicleInfo.styles';
import FallbackCarDefault from '../../../assets/fallback_car_default.png';
import { OffersTypes } from '../../../types';
import { numberFormatter } from '../../../functions/priceFormat';

interface OfferNoVehicleProps {
  offers: OffersTypes;
  isOfferPage: boolean;
  isVehicleLoading: boolean;
}

const OfferNoVehicle: React.FC<OfferNoVehicleProps> = ({ offers, isOfferPage }) => {
  const { t, i18n } = useTranslation();
  const lang = i18n.language;

  const isTablet = useMediaQuery({ query: device.tablet });
  const [isOpen, setIsOpen] = useState(false);
  const dropdownHeigh = 464;

  const image = offers?.image ? offers.image : FallbackCarDefault;
  const modelName = offers?.modelName;
  const trimName = offers?.trimName;

  const { dropdownAnimation, filtersAccordianAnimation } = useAnimations(isOpen, dropdownHeigh);
  return (
    <>
      {dropdownAnimation(
        (props, item) =>
          item && (
            <MobileWrapper style={props}>
              <VehicleInfoContainer style={filtersAccordianAnimation} data-testid="vehicle-info">
                <ImageWrapper data-testid="vehicle-info-image">
                  <VehicleImage src={image} />
                </ImageWrapper>
                <>
                  <VehicleName data-testid="vehicle-info-name">{modelName}</VehicleName>
                  <Trimline>{trimName}</Trimline>
                </>
                <CreditBonus>
                  {numberFormatter(offers?.offerDetails.creditBonus, lang)}{' '}
                  {t('digitalLeads.vehicle.offers.credit')}
                </CreditBonus>
                <CreditBonusDescription>
                  {offers?.offerDetails.creditBonusDisclaimer}
                </CreditBonusDescription>
              </VehicleInfoContainer>
            </MobileWrapper>
          ),
      )}
      {!isTablet && (
        <ExposedHeader
          isOpened={isOpen}
          setIsOpened={setIsOpen}
          modelName={modelName}
          isOfferPage={isOfferPage}
          offers={offers}
        />
      )}
      {isTablet && (
        <VehicleInfoContainer data-testid="vehicle-info-tablet">
          <ImageWrapper data-testid="vehicle-info-image">
            <VehicleImage src={image} />
          </ImageWrapper>

          <Title paddingTop>{t('digitalLeads.vehicle.offerOfInterest')}</Title>
          <OfferType>{t(`digitalLeads.vehicle.offers.${offers?.offerType}`)}</OfferType>
          <>
            <VehicleName data-testid="vehicle-info-name">{modelName}</VehicleName>
            <Trimline>{trimName}</Trimline>
          </>
          <CreditBonus>
            {numberFormatter(offers?.offerDetails.creditBonus, lang)}{' '}
            {t('digitalLeads.vehicle.offers.credit')}
          </CreditBonus>
          <CreditBonusDescription>
            {offers?.offerDetails.creditBonusDisclaimer}
          </CreditBonusDescription>
        </VehicleInfoContainer>
      )}
    </>
  );
};

export default OfferNoVehicle;
